// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__PJcZM","search":"Settings_search__3gJHx","filter":"Settings_filter__3bRF2"};